import { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { useShufersalCredentials } from '@/lib/hooks/useShufersalCredentials';
import { Loader2 } from "lucide-react";

export function ShufersalCredentialsForm({ onComplete }: { onComplete: () => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const { saveCredentials } = useShufersalCredentials();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await saveCredentials(email, password);
      onComplete();
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6 relative z-50">
      <div className="space-y-2 text-center">
        <h2 className="text-2xl font-bold">הגדרת חשבון שופרסל</h2>
        <p className="text-muted-foreground">
          אנא הזן את פרטי החשבון שלך בשופרסל
        </p>
      </div>

      {error && (
        <Alert variant="destructive">
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}

      <div className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="shufersalEmail">אימייל שופרסל</Label>
          <Input
            id="shufersalEmail"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            required
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="shufersalPassword">סיסמת שופרסל</Label>
          <Input
            id="shufersalPassword"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="הזן סיסמה"
            required
          />
        </div>
      </div>

      <Button type="submit" className="w-full" disabled={loading}>
        {loading && <Loader2 className="ml-2 h-4 w-4 animate-spin" />}
        שמור פרטי התחברות
      </Button>
    </form>
  );
} 